module.exports = __webpack_public_path__ + "media/images/members/frederick_de_armas-b4f6fb1c56c57d74e46b0296f8a7bde3.jpg";